<script setup lang="ts">
  import { loaderClass, loaderVariants } from './Loader.css';
  import SvgImage, { type SvgImageProps } from '../SvgImage/SvgImage.vue';
  import loader from '@tundr/theme-assets/icons/loader.svg';
  import { LoaderSize } from './Loader.utils';
  import { computed } from 'vue';
  export type LoaderProps = {
    id?: string;
    testId?: string;
    title?: string;
  } & Pick<SvgImageProps, 'fill'> & {
      size?: LoaderSize;
    };

  const sizesMap = {
    [LoaderSize.mini]: {
      width: 15,
      height: 15,
    },
    [LoaderSize.small]: {
      width: 22,
      height: 22,
    },
    [LoaderSize.medium]: {
      width: 40,
      height: 40,
    },
    [LoaderSize.large]: {
      width: 60,
      height: 60,
    },
    [LoaderSize.extra]: {
      width: 100,
      height: 100,
    },
  };

  const props = withDefaults(defineProps<LoaderProps>(), {
    size: LoaderSize.medium,
  });

  const loaderClasses = computed(() => {
    return [loaderClass, loaderVariants[props.size]];
  });
</script>

<template>
  <div :class="loaderClasses">
    <SvgImage
      :id="id"
      :title="title || 'Loading...'"
      :fill="props.fill || 'black'"
      :image="loader"
      :width="sizesMap[size].width"
      :height="sizesMap[size].height"
    />
  </div>
</template>
